import { connect } from "react-redux";
import { trialLicenseActions as actions } from "./trial-license-reducer";
import { trialLicenseSelector } from "./trial-license-reducer";

export function trialLicenseComposer(Component) {
    const mapStateToProps = function (state) {
        return {
            trialLicensePending: trialLicenseSelector.trialLicensePending(state),
            trialLicenseValidateSuccess: trialLicenseSelector.trialLicenseValidateSuccess(state),
            trialLicenseRequestSuccess: trialLicenseSelector.trialLicenseRequestSuccess(state),
            trialLicenseError: trialLicenseSelector.trialLicenseError(state),
            trialLicenseErrorMessage: trialLicenseSelector.trialLicenseErrorMessage(state),
            trialLicenseStatus: trialLicenseSelector.trialLicenseStatus(state)
        };
    };

    const mapDispatchToProps = function (dispatch) {
        return {
            trialLicenseRequest: Payload => dispatch(actions.trialLicenseRequest(Payload)),
            trialLicenseValidate: Payload => dispatch(actions.trialLicenseValidate(Payload))
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(Component);
}
